import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Dialog, Grid, TextField } from '@mui/material';

import { createBinCommodityAction } from 'redux-stores/actions';
import { AppDispatch } from 'redux-stores/store';

import * as S from '../styles/CreateBinDialog.styles';

export const CreateCommodityDialog: React.FC<{
  onClose: () => void;
  openModal: boolean;
}> = ({ onClose, openModal }) => {
  const [name, setName] = useState<string>('');
  const dispatch = useDispatch<AppDispatch>();

  const onConfirm = async (): Promise<void> => {
    const trimmedName = name.trim();
    if (trimmedName) {
      dispatch(createBinCommodityAction(trimmedName));
    }
  };

  return (
    <Dialog
      onClose={onClose}
      open={openModal}
      style={{ whiteSpace: 'pre-line' }}
    >
      <S.TitleWrapper>
        <S.Title data-testid="modalCreateCommodityHeader">
          Create New Commodity
        </S.Title>
      </S.TitleWrapper>
      <Grid container style={{ marginTop: '12px', width: '450px' }}>
        <S.FieldRowWrapper container item xs={12}>
          <Grid item xs={4}>
            <S.Text>Name</S.Text>
          </Grid>
          <S.InputWrapper>
            <TextField
              data-testid="inputCreateCommodityName"
              placeholder="Commodity Name"
              variant="outlined"
              value={name}
              onChange={(event): void => setName(event.target.value)}
              fullWidth
            />
          </S.InputWrapper>
        </S.FieldRowWrapper>
      </Grid>
      <S.FooterWrapper>
        <S.CancelButton
          data-testid="buttonCreateCommodityNoModal"
          onClick={onClose}
        >
          Cancel
        </S.CancelButton>
        <S.OKButton
          data-testid="buttonCreateCommodityYesModal"
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          Submit
        </S.OKButton>
      </S.FooterWrapper>
    </Dialog>
  );
};
